import { useLocation } from 'react-router-dom';
import {
    FORCED_RANKING_SEARCH,
    RELEVANCE_TEST_DEFINITION_SEARCH,
    SETS_PLAYGROUND,
    SETS_CONFIG_SEARCH,
    MATCHING_VISUALIZER,
} from 'src/lib/routes';

export const TOOL_PATHS = {
    RELEVANCE: RELEVANCE_TEST_DEFINITION_SEARCH,
    DCFR: FORCED_RANKING_SEARCH,
    SETS_PLAYGROUND,
    SETS_CONFIG: SETS_CONFIG_SEARCH,
    MATCHING_VISUALIZER,
    INGEST: '/',
} as const;

const TOOL_TITLES: Record<string, string> = {
    [TOOL_PATHS.RELEVANCE]: 'Go to relevance test search page',
    [TOOL_PATHS.DCFR]: 'Go to Design Consolidation Forced Ranking search page',
    [TOOL_PATHS.INGEST]: 'Go to ingest config search page',
    [TOOL_PATHS.SETS_PLAYGROUND]: 'Go to sets playground page',
    [TOOL_PATHS.SETS_CONFIG]: 'Go to sets config search page',
};

type ToolContext = {
    currentTool: string;
    tooltip: string;
    showBreadcrumbs: boolean
};

export function useToolContext(): ToolContext {
    const { pathname } = useLocation();

    const isRelevance = pathname.includes(TOOL_PATHS.RELEVANCE);
    const isDcfr = pathname.includes(TOOL_PATHS.DCFR);
    const isSetsPlayground = pathname.includes(TOOL_PATHS.SETS_PLAYGROUND);
    const isSetsConfig = pathname.includes(TOOL_PATHS.SETS_CONFIG);
    const isMatchingVisualizer = pathname.includes(TOOL_PATHS.MATCHING_VISUALIZER);

    let currentTool: string = TOOL_PATHS.INGEST;

    if (isRelevance) {
        currentTool = TOOL_PATHS.RELEVANCE;
    } else if (isDcfr) {
        currentTool = TOOL_PATHS.DCFR;
    } else if (isSetsPlayground) {
        currentTool = TOOL_PATHS.SETS_PLAYGROUND;
    } else if (isSetsConfig) {
        currentTool = TOOL_PATHS.SETS_CONFIG;
    } else if (isMatchingVisualizer) {
        currentTool = TOOL_PATHS.MATCHING_VISUALIZER;
    }

    return {
        currentTool,
        tooltip: TOOL_TITLES[currentTool] || TOOL_TITLES[TOOL_PATHS.INGEST],
        showBreadcrumbs: !isRelevance && !isDcfr && !isSetsPlayground && !isSetsConfig && !isMatchingVisualizer,
    };
}
